import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "selectAllPayments", "paymentCheckbox", "assignPaymentsBtn",
    "paymentRow", "paymentTableBody", "paymentSelectionCount"
  ]

  connect() {
    this.updatePaymentSelection()
    this.initializeCollapseListeners()
  }

  // Initialize Bootstrap collapse event listeners for chevron rotation
  initializeCollapseListeners() {
    const collapseElements = this.element.querySelectorAll('.collapse')

    collapseElements.forEach(collapseEl => {
      collapseEl.addEventListener('show.bs.collapse', (event) => {
        this.handleRowExpand(event.target)
      })

      collapseEl.addEventListener('hide.bs.collapse', (event) => {
        this.handleRowCollapse(event.target)
      })
    })
  }

  // Rotate chevron icon when expanding
  handleRowExpand(collapseElement) {
    const rowId = collapseElement.id
    const row = this.element.querySelector(`[data-bs-target="#${rowId}"]`)
    if (row) {
      const chevron = row.querySelector('.chevron-icon')
      if (chevron) {
        chevron.classList.remove('fa-chevron-right')
        chevron.classList.add('fa-chevron-down')
      }
    }
  }

  // Rotate chevron icon back when collapsing
  handleRowCollapse(collapseElement) {
    const rowId = collapseElement.id
    const row = this.element.querySelector(`[data-bs-target="#${rowId}"]`)
    if (row) {
      const chevron = row.querySelector('.chevron-icon')
      if (chevron) {
        chevron.classList.remove('fa-chevron-down')
        chevron.classList.add('fa-chevron-right')
      }
    }
  }

  // Payment selection
  toggleAllPayments(event) {
    const checked = event.target.checked
    this.paymentCheckboxTargets.forEach(checkbox => {
      // Only toggle visible rows
      if (checkbox.closest('tr').style.display !== 'none') {
        checkbox.checked = checked
      }
    })
    this.updatePaymentSelection()
  }

  updatePaymentSelection() {
    const visibleCheckboxes = this.paymentCheckboxTargets.filter(cb =>
      cb.closest('tr').style.display !== 'none'
    )
    const checkedCount = visibleCheckboxes.filter(cb => cb.checked).length

    if (this.hasAssignPaymentsBtnTarget) {
      this.assignPaymentsBtnTarget.disabled = checkedCount === 0
    }

    if (this.hasPaymentSelectionCountTarget) {
      this.paymentSelectionCountTarget.textContent = `${checkedCount} sélectionné${checkedCount > 1 ? 's' : ''}`
    }

    // Update select all checkbox state
    if (this.hasSelectAllPaymentsTarget && visibleCheckboxes.length > 0) {
      const allChecked = visibleCheckboxes.every(cb => cb.checked)
      const someChecked = visibleCheckboxes.some(cb => cb.checked)
      this.selectAllPaymentsTarget.checked = allChecked
      this.selectAllPaymentsTarget.indeterminate = someChecked && !allChecked
    }
  }

  // Legacy methods for backward compatibility
  updateButtonStates() {
    this.updatePaymentSelection()
  }

  paymentCheckboxTargetConnected() {
    this.updatePaymentSelection()
  }
}
